import { setAuthToken } from "./session_api_util";
import { logout } from "../actions/session_actions";

// Force logout + redirect no matter where the 401 happens.
export const forceLogoutAndRedirect = () => {
  try {
    localStorage.removeItem("jwtToken");
  } catch (e) {}

  // clears axios default Authorization header
  try {
    setAuthToken(false);
  } catch (e) {}

  // if we can access the store, also clear redux session
  try {
    if (window.__COSMETINK_STORE__) {
      window.__COSMETINK_STORE__.dispatch(logout());
    }
  } catch (e) {}

  // hard redirect to login
  window.location.href = "/#/login?expired=1";
};
